import { Contract, ServiceConfigOption } from '@/modules/Contract/types'
import { useEffect } from 'react'
import { Path, useFormContext, useWatch } from 'react-hook-form'

const usePrepaid = ({ index }: { index: number }) => {
    const { control, setValue } = useFormContext<Contract>()

    const prepaid = useWatch({
        control,
        name: `order.products.[${index}].prepaid` as Path<Contract>,
    })

    const serviceConfigOptions = useWatch({
        control,
        name: `order.products.[${index}].service_configoptions` as Path<Contract>,
    }) as ServiceConfigOption[] | undefined

    useEffect(() => {
        // Kiểm tra serviceConfigOptions có tồn tại và là array không
        if (!serviceConfigOptions || !Array.isArray(serviceConfigOptions)) {
            return
        }

        const options = serviceConfigOptions.map(
            (option: ServiceConfigOption) => {
                return {
                    ...option,
                    commitment_prepaid: prepaid,
                }
            }
        )

        setValue(
            `order.products.[${index}].service_configoptions` as Path<Contract>,
            options
        )
    }, [prepaid, serviceConfigOptions?.length, setValue, index])
}

export default usePrepaid
